import { post, get,postJson,deleteApi,put,imagePost } from './axios'

const RESOURCE_BASE_PATH = '/activityCodeConfig';

/***
 * 查询活动列表
 * @param p
 */
export const getActivityCodeConfig = p => get(`${RESOURCE_BASE_PATH}/getActivityCodeConfig`, p)

/***
 * 查询单个活动码配置信息 & 新建任务获取ID(参数为空)
 * @param p
 */
export const getInfo = p => get(`${RESOURCE_BASE_PATH}/get`, p)

/***
 * 更新/新建活动码配置信息
 * @param p
 */
export const updateActivityCodeConfig = p => postJson(`${RESOURCE_BASE_PATH}/updateActivityCodeConfig`, p)

/***
 * 添加地区信息
 * @param p
 */
export const addActivity = p => put(`${RESOURCE_BASE_PATH}/addActivityCodeProvinceConfig`, p)

/***
 * 上传活动码
 * @param p
 */
export const importActivityCode = p => imagePost(`${RESOURCE_BASE_PATH}/importActivityCode`, p)

/***
 * 删除活动码任务
 * @param id
 */
export const deleteActivity = id => deleteApi(`${RESOURCE_BASE_PATH}/deleteActivityCodeConfig/${id}`)

/***
 * 开启关闭活动
 * @param p
 */
export const activitySwitch = p => post(`${RESOURCE_BASE_PATH}/ActivityCodeConfigSwitch`,p)

/***
 * 活动短信记录
 * @param p
 */
export const getActivityCodeSmsrecord = p => get(`${RESOURCE_BASE_PATH}/getActivityCodeSmsrecord`,p)

// 获取活动列表
export const getCopyActivityList = (p) => get(`/hd/activity/list`,p);

// 按功能区查询有效的提示文案
export const getValidMessage = (p) => get(`/noticeMessage/validByArea`,p);
